module.exports = __webpack_public_path__ + "Flag-516.fd92696b9e4ac135bc5ddcf78d657f1e.svg";